import React, { ReactElement, useState } from 'react';
import { Icon } from '../icon/Icon';
import styles from '../accordion/Accordion.module.scss';

export const Accordion = (props: {
    title: string;
    component: ReactElement;
    id?: string;
}): ReactElement => {
    const { title, component, id } = props;
    const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

    const handleToggle = () => setIsAccordionExpanded(!isAccordionExpanded);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleToggle();
        }
    };

    const accordionId = id || `accordion-${title.replace(/\s+/g, '-').toLowerCase()}`;
    const contentId = `${accordionId}-content`;

    return (
        <>
            <button
                type="button"
                className={styles.accordionContainer}
                onClick={handleToggle}
                onKeyDown={handleKeyDown}
                aria-expanded={isAccordionExpanded}
                aria-controls={contentId}
                id={accordionId}
            >
                <span className={styles.accordionTitleContainer}>
                    {title}
                </span>
                <span className={styles.accordionIconContainer} aria-hidden="true">
                    <Icon 
                        icon={isAccordionExpanded ? "chevron down" : "chevron right"} 
                        color="black" 
                        size="large" 
                    />
                </span>
            </button>
            <div
                id={contentId}
                role="region"
                aria-labelledby={accordionId}
                hidden={!isAccordionExpanded}
            >
                {component}
            </div>
        </>
    );
};
